import { useState, useEffect, memo, useCallback } from "react";
import { CSVLink } from "react-csv";
import AnimacionCarga from "../components/animacion_de_carga";
import BarraSuperior from "../components/barra_superior";
import TablaGenerica from "../components/tablas";
import { obtenerAnuncios } from "../../functions/consultas";
import Swal from "sweetalert2";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import { crearRegistro, actualizarRegistro, eliminarRegistro } from "../../functions/crud";
import BotonSOS from "../components/sos/boton_sos";
import "bootstrap-icons/font/bootstrap-icons.css";


const COLUMNAS = [
  { label: "Fecha",       key: "fecha"       },
  { label: "Hora",        key: "hora"        },
  { label: "Título",      key: "titulo"      },
  { label: "Descripción", key: "descripcion" },
  { label: "Teléfono",    key: "telefono"    },
  { label: "Foto",        key: "url_foto_1"  },
];

const CATEGORIAS = [
  "Alquiler apartamento", "Venta apartamento", "Alquiler parqueadero",
  "Venta parqueadero", "Servicios", "Compra/Venta", "Otro",
];

const ESTRUCTURA_ANUNCIO_VACIO = {
  casa: "", categoria: "", contador: 0, correo: "", descripcion: "",
  estado: "Aprobado", fecha: "", hora: "", idUnico: "", motivo_rechazo: " ",
  precio: "0", sitio_web: " ", telefono: "", titulo: "",
  url_foto_1: "", url_foto_2: "", url_foto_3: "",
  url_foto_4: "", url_foto_5: "", url_foto_6: "", url_pdf: "",
};

const estiloCSV = { padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" };


const obtenerFechaHora = () => {
  const ahora = new Date();
  return {
    fecha:     ahora.toISOString().split("T")[0],
    hora:      ahora.toTimeString().split(" ")[0].substring(0, 5),
    timestamp: ahora.toISOString().replace("T", " ").replace("Z", ""),
  };
};

const construirAnuncio = (formValues, urlFoto, anuncioExistente = null) => {
  const { fecha, hora, timestamp } = obtenerFechaHora();
  return {
    ...ESTRUCTURA_ANUNCIO_VACIO,
    ...(anuncioExistente || {}),
    casa:        formValues.casa,
    categoria:   formValues.categoria,
    correo:      formValues.correo,
    descripcion: formValues.descripcion,
    fecha, hora,
    idUnico:     anuncioExistente?.idUnico || timestamp,
    precio:      formValues.precio,
    sitio_web:   formValues.sitio_web,
    telefono:    formValues.telefono,
    titulo:      formValues.titulo,
    url_foto_1:  urlFoto,
  };
};

const useEsMobil = () => {
  const [es, setEs] = useState(window.innerWidth < 700);
  useEffect(() => {
    const fn = () => setEs(window.innerWidth < 700);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return es;
};


const SWAL_ESTILOS = `<style>
  .swal2-input,.swal2-textarea,.swal2-select,.swal2-file{
    margin:0!important;width:100%!important;box-sizing:border-box!important;
    padding:7px 10px!important;border:1px solid #d1d5db!important;
    border-radius:5px!important;font-size:13px!important;
  }
  .swal2-textarea{min-height:70px!important;resize:vertical!important;}
  .swal2-file{padding:8px 10px!important;border:1px dashed #d1d5db!important;cursor:pointer!important;}
  .form-row{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px;}
  .form-field{display:flex;flex-direction:column;gap:4px;margin-bottom:10px;}
  .form-field label{color:#555;font-size:12px;font-weight:500;}
</style>`;

const formularioHTML = (anuncio = null) => `
  ${SWAL_ESTILOS}
  <div style="text-align:left;padding:12px 16px 4px;">
    <div class="form-row">
      <div class="form-field">
        <label>Categoría</label>
        <select id="categoria" class="swal2-select">
          <option value="">Selecciona...</option>
          ${CATEGORIAS.map(c => `<option value="${c}" ${anuncio?.categoria === c ? "selected" : ""}>${c}</option>`).join("")}
        </select>
      </div>
      <div class="form-field">
        <label>Título</label>
        <input id="titulo" class="swal2-input" placeholder="Título del anuncio" value="${anuncio?.titulo || ""}">
      </div>
    </div>
    <div class="form-field">
      <label>Descripción</label>
      <textarea id="descripcion" class="swal2-textarea" placeholder="Describe tu anuncio...">${anuncio?.descripcion || ""}</textarea>
    </div>
    <div class="form-row">
      <div class="form-field">
        <label>Teléfono</label>
        <input id="telefono" type="tel" class="swal2-input" placeholder="Teléfono de contacto" value="${anuncio?.telefono || ""}">
      </div>
      <div class="form-field">
        <label>Precio (Opcional)</label>
        <input id="precio" type="number" class="swal2-input" placeholder="0" value="${anuncio?.precio || "0"}">
      </div>
    </div>
    <div class="form-row">
      <div class="form-field">
        <label>Sitio Web (Opcional)</label>
        <input id="sitio_web" type="url" class="swal2-input" placeholder="https://..."
          value="${anuncio?.sitio_web && anuncio.sitio_web.trim() !== " " ? anuncio.sitio_web : ""}">
      </div>
      <div class="form-field">
        <label>Imagen ${anuncio ? "(vacío = mantener)" : "(Opcional)"}</label>
        <input id="archivo" type="file" accept="image/*" class="swal2-file">
      </div>
    </div>
    ${anuncio?.url_foto_1 ? `
      <div style="text-align:center;background:#f8f9fa;padding:8px;border-radius:8px;margin-bottom:8px;">
        <img src="${anuncio.url_foto_1}" style="max-width:100%;max-height:120px;border-radius:6px;">
      </div>` : ""}
    <div id="preview" style="text-align:center;"></div>
  </div>`;

const attachPreview = () => {
  const archivo = document.getElementById("archivo");
  const preview = document.getElementById("preview");
  archivo.addEventListener("change", () => {
    const file = archivo.files[0];
    preview.innerHTML = file
      ? `<div style="background:#f8f9fa;padding:15px;border-radius:8px;border:2px dashed #d1d5db;">
           <img src="${URL.createObjectURL(file)}" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;">
         </div>`
      : "";
  });
};

const validarFormulario = () => {
  const categoria   = document.getElementById("categoria").value.trim();
  const titulo      = document.getElementById("titulo").value.trim();
  const descripcion = document.getElementById("descripcion").value.trim();
  const telefono    = document.getElementById("telefono").value.trim();
  const precio      = document.getElementById("precio").value.trim() || "0";
  const sitio_web   = document.getElementById("sitio_web").value.trim() || " ";
  const archivo     = document.getElementById("archivo").files[0];
  if (!categoria)   { Swal.showValidationMessage("La categoría es obligatoria");   return false; }
  if (!titulo)      { Swal.showValidationMessage("El título es obligatorio");       return false; }
  if (!descripcion) { Swal.showValidationMessage("La descripción es obligatoria"); return false; }
  if (!telefono)    { Swal.showValidationMessage("El teléfono es obligatorio");     return false; }
  return { categoria, titulo, descripcion, telefono, precio, sitio_web, archivo };
};

const abrirFormulario = (anuncio = null) =>
  Swal.fire({
    title:             anuncio ? "Editar Anuncio" : "Crear Anuncio",
    html:              formularioHTML(anuncio),
    didOpen:           attachPreview,
    showCancelButton:  true,
    confirmButtonText: anuncio ? "Guardar" : "Publicar",
    cancelButtonText:  "Cancelar",
    width: 780,
    preConfirm: () => {
      const datos = validarFormulario();
      if (!datos) return false;
      return {
        ...datos,
        correo: localStorage.getItem("CorreoElectronico") || anuncio?.correo || "",
        casa:   localStorage.getItem("Direccion")         || anuncio?.casa   || "",
      };
    },
  });

const abrirGestionEstado = (anuncio) =>
  Swal.fire({
    title: "Gestionar anuncio",
    html: `<div style="text-align:left;padding:10px 4px;">
      <p style="margin:0 0 12px;font-size:14px;color:#374151;"><strong>${anuncio.titulo}</strong> — ${anuncio.categoria}</p>
      <p style="margin:0 0 16px;font-size:13px;color:#6b7280;">Estado actual: <strong>${anuncio.estado}</strong></p>
      <label style="display:block;margin-bottom:6px;font-size:13px;color:#555;font-weight:500;">Nuevo estado</label>
    </div>`,
    input:             "select",
    inputOptions:      { Aprobado: "Aprobado", Pendiente: "Pendiente", Rechazado: "Rechazado" },
    inputValue:        anuncio.estado,
    showCancelButton:  true,
    confirmButtonText: "Guardar",
    cancelButtonText:  "Cancelar",
    width: 480,
  });


const BtnNav = ({ onClick, disabled, children }) => (
  <button onClick={onClick} disabled={disabled} style={{
    width: 40, height: 40, borderRadius: "50%", fontSize: 18,
    border: "1px solid #d1d5db",
    background: disabled ? "#f3f4f6" : "#fff",
    color:      disabled ? "#d1d5db" : "#374151",
    cursor:     disabled ? "default"  : "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
  }}>{children}</button>
);

const BtnAccion = ({ onClick, borde, fondo, color, children }) => (
  <button onClick={onClick} style={{
    padding: "6px 14px", fontSize: 13, borderRadius: 6, cursor: "pointer",
    border: `1px solid ${borde}`, background: fondo, color,
  }}>{children}</button>
);

const ModalAnuncio = ({ anuncio, onCerrar }) => {
  if (!anuncio) return null;
  return (
    <div onClick={onCerrar} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999, padding: 20,
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 16, overflow: "hidden",
        width: "100%", maxWidth: 900, boxShadow: "0 8px 40px rgba(0,0,0,0.3)",
        display: "flex", flexDirection: "column",
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid #e5e7eb" }}>
          <span style={{ color: "#1f2937", fontWeight: 600, fontSize: 16, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {anuncio.titulo}
          </span>
          <button onClick={onCerrar} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 24, cursor: "pointer", lineHeight: 1, padding: "0 4px" }}>×</button>
        </div>
        <img src={anuncio.url_foto_1} alt={anuncio.titulo}
          style={{ width: "100%", maxHeight: "65vh", objectFit: "contain", display: "block", background: "#f3f4f6" }} />
        <div style={{ padding: "16px 20px", borderTop: "1px solid #e5e7eb" }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#ff4747", textTransform: "uppercase", letterSpacing: 1 }}>
            {anuncio.categoria}
          </span>
          <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>{anuncio.descripcion}</p>
          {anuncio.precio && anuncio.precio !== "0" && (
            <p style={{ margin: "6px 0 0", fontSize: 16, fontWeight: 700, color: "#059669" }}>
              ${Number(anuncio.precio).toLocaleString("es-CO")}
            </p>
          )}
          <span style={{ fontSize: 12, color: "#9ca3af", marginTop: 6, display: "block" }}>
            {anuncio.fecha} {anuncio.hora}
          </span>
        </div>
      </div>
    </div>
  );
};

const TarjetaAnuncio = ({ anuncio, esMobil, esResidente, onVerMedia, onGestionar, onEditar, onEliminar }) => (
  <div style={{
    background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "100%", maxWidth: 1500,
    overflow: "hidden", display: "flex", flexDirection: esMobil ? "column" : "row",
  }}>
    <div style={esMobil ? { width: "100%", aspectRatio: "16/9", flexShrink: 0 } : { width: 380, minWidth: 380, flexShrink: 0 }}>
      {anuncio.url_foto_1 ? (
        <img src={anuncio.url_foto_1} alt={anuncio.titulo}
          style={{ width: "100%", height: "100%", minHeight: esMobil ? 0 : 240, objectFit: "cover", display: "block" }} />
      ) : (
        <div style={{ width: "100%", height: "100%", minHeight: esMobil ? 180 : 240, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: 64 }}>📋</span>
        </div>
      )}
    </div>

    <div style={{ flex: 1, padding: esMobil ? 16 : "24px 28px", display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: esMobil ? "flex-start" : "flex-end", alignItems: "center" }}>
        {anuncio.url_foto_1 && (
          <BtnAccion onClick={() => onVerMedia(anuncio)} borde="#d1d5db" fondo="#fff" color="#374151">Vista Previa</BtnAccion>
        )}
        {!esResidente && (
          <>
            <BtnAccion onClick={() => onGestionar(anuncio)} borde="#a5b4fc" fondo="#eef2ff" color="#4338ca">Estado</BtnAccion>
            <BtnAccion onClick={() => onEditar(anuncio)}    borde="#d1d5db" fondo="#f9fafb" color="#374151">✏ Editar</BtnAccion>
            <BtnAccion onClick={() => onEliminar(anuncio)}  borde="#fca5a5" fondo="#fef2f2" color="#dc2626">× Eliminar</BtnAccion>
          </>
        )}
      </div>

      <span style={{ fontSize: 12, fontWeight: 700, color: "#ff4747", textTransform: "uppercase", letterSpacing: 1 }}>
        {anuncio.categoria}
      </span>
      <h3 style={{ margin: 0, fontSize: esMobil ? 17 : 20, fontWeight: 700, color: "#1f2937", lineHeight: 1.3 }}>
        {anuncio.titulo}
      </h3>
      <p style={{ margin: 0, fontSize: esMobil ? 14 : 15, color: "#6b7280", lineHeight: 1.7, flex: 1 }}>
        {anuncio.descripcion}
      </p>
      {anuncio.precio && anuncio.precio !== "0" && (
        <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#059669" }}>
          ${Number(anuncio.precio).toLocaleString("es-CO")}
        </p>
      )}
      <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 12, marginTop: "auto", display: "flex", flexDirection: "column", gap: 6 }}>
        {anuncio.telefono && <span style={{ fontSize: 14, color: "#374151" }}>{anuncio.telefono}</span>}
        {anuncio.sitio_web && anuncio.sitio_web.trim() && anuncio.sitio_web.trim() !== " " && (
          <a href={anuncio.sitio_web} target="_blank" rel="noreferrer" style={{ fontSize: 14, color: "#3b82f6" }}>
            {anuncio.sitio_web}
          </a>
        )}
        <span style={{ fontSize: 13, color: "#9ca3af" }}>{anuncio.fecha} {anuncio.hora}</span>
      </div>
    </div>
  </div>
);

const GaleriaSeccion = ({ lista, seccionKey, color, titulo, indices, onNavegar, ...propsTarjeta }) => {
  if (lista.length === 0) return null;
  const idx = indices[seccionKey] ?? 0;
  return (
    <div style={{ width: "100%", maxWidth: 1500, display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{
          fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1,
          color, background: `${color}18`, border: `1px solid ${color}40`, borderRadius: 20, padding: "4px 14px",
        }}>
          {titulo} ({lista.length})
        </span>
        <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
      </div>
      <TarjetaAnuncio anuncio={lista[idx]} {...propsTarjeta} />
      {lista.length > 1 && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16 }}>
          <BtnNav onClick={() => onNavegar(seccionKey, -1, lista.length)} disabled={idx === 0}>‹</BtnNav>
          <span style={{ fontSize: 13, color: "#9ca3af", minWidth: 60, textAlign: "center" }}>{idx + 1} de {lista.length}</span>
          <BtnNav onClick={() => onNavegar(seccionKey, 1, lista.length)} disabled={idx === lista.length - 1}>›</BtnNav>
        </div>
      )}
    </div>
  );
};


const ListadoAnuncios = memo(() => {
  const [datos,        setDatos]        = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [indices,      setIndices]      = useState({ todos: 0, pendientes: 0, rechazados: 0, aprobados: 0 });
  const [modalAnuncio, setModalAnuncio] = useState(null);

  const esMobil     = useEsMobil();
  const esResidente = localStorage.getItem("Permisos") === "RESIDENTE";
  const nit         = localStorage.getItem("CodigoCliente");

  const cargar = useCallback(async () => {
    try {
      const data = await obtenerAnuncios();
      let lista = Object.entries(data || {})
        .map(([id, item]) => ({ id, ...item }))
        .sort((a, b) => new Date(`${b.fecha} ${b.hora || "00:00"}`) - new Date(`${a.fecha} ${a.hora || "00:00"}`));
      if (esResidente) lista = lista.filter(a => a.estado === "Aprobado");
      setDatos(lista);
      setIndices({ todos: 0, pendientes: 0, rechazados: 0, aprobados: 0 });
    } catch (e) {
      console.error("Error al obtener anuncios:", e);
    } finally {
      setCargando(false);
    }
  }, [esResidente]);

  useEffect(() => { cargar(); }, [cargar]);

  const guardarAnuncio = useCallback(async (anuncio = null) => {
    const { value } = await abrirFormulario(anuncio);
    if (!value) return;
    try {
      const { fecha, timestamp } = obtenerFechaHora();
      let urlFoto = anuncio?.url_foto_1 || "";
      if (value.archivo) {
        const nombre = `${timestamp}foto_0.jpeg`;
        urlFoto = await subirArchivoFirebase(`uploads/${nit}/${fecha}/${nombre}`, value.archivo);
      }
      const data = construirAnuncio(value, urlFoto, anuncio);
      if (anuncio) {
        await actualizarRegistro(`coordi_ph/${nit}/anuncios/${anuncio.id}`, data);
        Swal.fire("Éxito", "Anuncio actualizado correctamente", "success");
      } else {
        await crearRegistro(`coordi_ph/${nit}/anuncios/`, { ...data, estado: esResidente ? "Pendiente" : "Aprobado" });
        Swal.fire("Éxito", esResidente ? "Anuncio enviado, quedará visible cuando sea aprobado por la administración." : "Anuncio creado correctamente", "success");
      }
      cargar();
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudo guardar el anuncio", "error");
    }
  }, [nit, esResidente, cargar]);

  const eliminarAnuncio = useCallback(async (anuncio) => {
    const { isConfirmed } = await Swal.fire({
      title: "¿Eliminar Anuncio?",
      html: `<div style="text-align:left;padding:15px;">
        <div style="background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #e74c3c;">
          <strong style="display:block;margin-bottom:8px;color:#2c3e50;">${anuncio.titulo}</strong>
          <p style="color:#7f8c8d;margin:5px 0;font-size:14px;">Categoría: ${anuncio.categoria}</p>
          <p style="color:#7f8c8d;margin:5px 0;font-size:14px;">Teléfono: ${anuncio.telefono}</p>
          <p style="color:#7f8c8d;margin:0;font-size:14px;">${anuncio.descripcion}</p>
        </div>
        <p style="margin-top:15px;color:#e74c3c;">Esta acción no se puede deshacer</p>
      </div>`,
      icon: "warning", showCancelButton: true,
      confirmButtonColor: "#d33", confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
    });
    if (!isConfirmed) return;
    try {
      await eliminarRegistro(`coordi_ph/${nit}/anuncios/${anuncio.id}`);
      Swal.fire({ title: "Eliminado", text: "Anuncio eliminado correctamente", icon: "success", timer: 2000, showConfirmButton: false });
      cargar();
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudo eliminar el anuncio", "error");
    }
  }, [nit, cargar]);

  const gestionarEstado = useCallback(async (anuncio) => {
    const { value: nuevoEstado } = await abrirGestionEstado(anuncio);
    if (!nuevoEstado || nuevoEstado === anuncio.estado) return;
    try {
      await actualizarRegistro(`coordi_ph/${nit}/anuncios/${anuncio.id}/estado`, nuevoEstado);
      Swal.fire({ title: "Actualizado", text: `Anuncio ${nuevoEstado.toLowerCase()}`, icon: "success", timer: 1800, showConfirmButton: false });
      cargar();
    } catch {
      Swal.fire("Error", "No se pudo actualizar el estado", "error");
    }
  }, [nit, cargar]);

  const navegar = (seccion, dir, total) =>
    setIndices(prev => ({ ...prev, [seccion]: Math.min(Math.max(prev[seccion] + dir, 0), total - 1) }));

  if (cargando) return <AnimacionCarga />;

  if (!esResidente) return (
    <>
      <BarraSuperior />
      <TablaGenerica
        datos={datos}
        titulos={COLUMNAS.map(c => c.label.toUpperCase())}
        campos={COLUMNAS.map(c => c.key)}
        mostrarBarraSuperior={false}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        botones={[
          { texto: "Estado", icono: "bi-toggle-on", accion: gestionarEstado },
          { texto: "Editar", icono: "bi-pencil", accion: (a) => guardarAnuncio(a) },
          { texto: "Eliminar", icono: "bi-trash", accion: eliminarAnuncio },
        ]}
        contenidoExtra={
          <>
            <button onClick={cargar} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <CSVLink data={datos} headers={COLUMNAS} filename="listado_anuncios.csv" separator=";" style={estiloCSV} title="Exportar"><i className="bi bi-download" /></CSVLink>
            <button onClick={() => guardarAnuncio()} title="Nuevo Anuncio"><i className="bi bi-plus-lg" /></button>
          </>
        }
      />
      <BotonSOS />
    </>
  );

  const propsTarjeta = { esMobil, esResidente, onVerMedia: setModalAnuncio, onGestionar: gestionarEstado, onEditar: guardarAnuncio, onEliminar: eliminarAnuncio };
  const pendientes   = datos.filter(a => a.estado === "Pendiente");
  const rechazados   = datos.filter(a => a.estado === "Rechazado");
  const aprobados    = datos.filter(a => a.estado === "Aprobado");

  return (
    <>
      <BarraSuperior />
      <ModalAnuncio anuncio={modalAnuncio} onCerrar={() => setModalAnuncio(null)} />

      {esResidente ? (
        <div style={{ padding: "20px 16px 100px", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
          {datos.length === 0 && <p style={{ color: "#888", fontSize: 15 }}>No hay anuncios disponibles.</p>}
          {datos[indices.todos] && <TarjetaAnuncio anuncio={datos[indices.todos]} {...propsTarjeta} />}
          {datos.length > 1 && (
            <div style={{
              position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)",
              display: "flex", alignItems: "center", gap: 16,
              background: "rgba(255,255,255,0.95)", backdropFilter: "blur(6px)",
              border: "1px solid #e5e7eb", borderRadius: 50,
              padding: "10px 20px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 900,
            }}>
              <BtnNav onClick={() => navegar("todos", -1, datos.length)} disabled={indices.todos === 0}>‹</BtnNav>
              <span style={{ fontSize: 13, color: "#9ca3af", minWidth: 60, textAlign: "center" }}>
                {indices.todos + 1} de {datos.length}
              </span>
              <BtnNav onClick={() => navegar("todos", 1, datos.length)} disabled={indices.todos === datos.length - 1}>›</BtnNav>
            </div>
          )}
        </div>
      ) : (
        <div style={{ padding: "20px 16px 100px", display: "flex", flexDirection: "column", alignItems: "center", gap: 32 }}>
          {datos.length === 0 && <p style={{ color: "#888", fontSize: 15 }}>No hay anuncios disponibles.</p>}
          <GaleriaSeccion lista={pendientes} seccionKey="pendientes" color="#d97706" titulo="Pendientes de aprobación" indices={indices} onNavegar={navegar} {...propsTarjeta} />
          <GaleriaSeccion lista={rechazados} seccionKey="rechazados" color="#dc2626" titulo="Rechazados"               indices={indices} onNavegar={navegar} {...propsTarjeta} />
          <GaleriaSeccion lista={aprobados}  seccionKey="aprobados"  color="#059669" titulo="Aprobados"                indices={indices} onNavegar={navegar} {...propsTarjeta} />
        </div>
      )}

      <BotonSOS />
    </>
  );
});

export default ListadoAnuncios;
